import PropTypes from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const reviewsPropType = PropTypes.shape({
  pagination: PropTypes.shape({
    page: PropTypes.number,
    per_page: PropTypes.number,
    total: PropTypes.number,
  }),
  bottomline: PropTypes.shape({
    total_review: PropTypes.number,
    average_score: PropTypes.number,
    total_organic_reviews: PropTypes.number,
    organic_average_score: PropTypes.number,
    star_distribution: PropTypes.objectOf(PropTypes.number),
    custom_fields_bottomline: PropTypes.objectOf(PropTypes.shape({
      title: PropTypes.string,
      type: PropTypes.string,
      score: PropTypes.number,
      average_score: PropTypes.number,
    })),
  }),
  grouping_data: PropTypes.objectOf(PropTypes.shape({
    product_url: PropTypes.string,
    product_name: PropTypes.string,
  })),
  products: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    domain_key: PropTypes.string,
    name: PropTypes.string,
    social_links: PropTypes.shape({
      linkedin: PropTypes.string,
      facebook: PropTypes.string,
      twitter: PropTypes.string,
      google_oauth2: PropTypes.string,
    }),
    embedded_widget_link: PropTypes.string,
    testimonials_product_link: PropTypes.string,
    product_link: PropTypes.string,
    image_url: PropTypes.string,
  })),
  product_tags: PropTypes.arrayOf(PropTypes.any),
  reviews: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    score: PropTypes.number,
    votes_up: PropTypes.number,
    votes_down: PropTypes.number,
    content: PropTypes.string,
    title: PropTypes.string,
    created_at: PropTypes.string,
    verified_buyer: PropTypes.bool,
    source_review_id: PropTypes.string,
    sentiment: PropTypes.number,
    custom_fields: PropTypes.objectOf(PropTypes.shape({
      title: PropTypes.string,
      form_id: PropTypes.number,
      field_type: PropTypes.string,
      value: PropTypes.any,
    })),
    product_id: PropTypes.number,
    images_data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      thumb_url: PropTypes.string,
      original_url: PropTypes.string,
    })),
    videos_data: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      entry_id: PropTypes.string,
      thumbnail_url: PropTypes.string,
      gallery_media_id: PropTypes.string,
      syndication: PropTypes.string,
    })),
    user: PropTypes.shape({
      user_id: PropTypes.number,
      social_image: PropTypes.string,
      user_type: PropTypes.string,
      is_social_connected: PropTypes.number,
      display_name: PropTypes.string,
    }),
  })),
});
